import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

import { RenumerationModalContextType } from '../types/RenumerationModalContextType';

export const renumerationModalInitValue: RenumerationModalContextType = {
  data: {
    scriptureView: true,
    date: '',
    file: undefined,
    comments: '',
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    lastOperationDate: '',
    isAutomaticRenumeration: true,
    selectedHoldingClassOption: null,
    holdingClassOptions: [],
    selectedPartnerOption: null,
    partnerOptions: [],
    ranges: [],
    reassignedRanges: [],
    savedRanges: [],
    page: 1,
    rowsPerPage: 5,
    totalRanges: 0,
    totalClasses: 0,
    totalPartners: 0,
    totalShares: 0,
    overlapCount: 0,
    overlaps: [],
    historyMovements: [],
    isLoadingRanges: false,
    isEntireClassRenumeration: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleChangeRenumerationMode(): void {},
    handleChangeHoldingClass(): void {},
    handleSearchHoldingClass: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangePartner(): void {},
    handleSearchPartner: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangePage(): void {},
    handleChangeRowsPerPage(): void {},
    handleChangeIsEntireClassRenumeration(): void {},
    handleEditRange(): void {},
    handleSaveMovement(): void {},
    handleSaveRenumeration(): void {},
  },
};
